export const languages = [
  {code:'en', name:'English', direction:'ltr'},
  {code:'zh-Hans', name:'简体中文', direction:'ltr'},
  {code:'zh-Hant', name:'繁體中文', direction:'ltr'},
  {code:'es', name:'Español', direction:'ltr'},
  {code:'fr', name:'Français', direction:'ltr'},
  {code:'de', name:'Deutsch', direction:'ltr'},
  {code:'pt-BR', name:'Português (Brasil)', direction:'ltr'},
  {code:'ja', name:'日本語', direction:'ltr'},
  {code:'ko', name:'한국어', direction:'ltr'},
  {code:'ar', name:'العربية', direction:'rtl'},
] as const;
export type AppLocale = typeof languages[number]['code'];
export const localeCodes = languages.map(language => language.code) as [AppLocale,...AppLocale[]];
export function matchLocale(input: string | null | undefined): AppLocale | null {
  if (!input || input.length > 100) return null;
  const tag = input.trim().replaceAll('_','-').toLowerCase();
  if (tag==='zh' || tag.startsWith('zh-')) return /(?:hant|tw|hk|mo)(?:-|$)/.test(tag) ? 'zh-Hant' : 'zh-Hans';
  if (tag==='pt' || tag.startsWith('pt-')) return 'pt-BR';
  return localeCodes.find(code=>code.toLowerCase()===tag || code.toLowerCase()===tag.split('-')[0]) || null;
}
export function negotiateLocale(header: string | null | undefined): AppLocale {
  const choices = (header || '').slice(0,1000).split(',').map((part,index)=> {
    const [tag,...parameters]=part.trim().split(';');
    const quality=parameters.find(p=>p.trim().startsWith('q='));
    const q=quality ? Number(quality.trim().slice(2)) : 1;
    return {locale:matchLocale(tag),q,index};
  }).filter(v=>v.locale && Number.isFinite(v.q) && v.q>0 && v.q<=1).sort((a,b)=>b.q-a.q || a.index-b.index);
  return choices[0]?.locale || 'en';
}
export function direction(locale: AppLocale) { return locale==='ar' ? 'rtl' : 'ltr'; }

export function challengeLanguage(locale: AppLocale): string { return locale === "zh-Hans" ? "zh-cn" : locale === "zh-Hant" ? "zh-tw" : locale.toLowerCase(); }
export function formatMessage(message:string,values:Record<string,string|number>={}) { return message.replace(/\{(\w+)\}/g,(placeholder,name)=>Object.hasOwn(values,name)?String(values[name]):placeholder); }
